/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Tells the public-site SPA which self-edit page to render for the logged-in member.
 * @export
 * @interface WebApiPublicSiteDtoPublicSessionDto
 */
export interface WebApiPublicSiteDtoPublicSessionDto {
    /**
     * 
     * @type {boolean}
     * @memberof WebApiPublicSiteDtoPublicSessionDto
     */
    isFamilyMember?: boolean;
    /**
     *
     * @type {number}
     * @memberof WebApiPublicSiteDtoPublicSessionDto
     */
    familyMemberSelfServiceLimit?: number;
    /**
     *
     * @type {number}
     * @memberof WebApiPublicSiteDtoPublicSessionDto
     */
    familyMemberCount?: number;
}

/**
 * Check if a given object implements the WebApiPublicSiteDtoPublicSessionDto interface.
 */
export function instanceOfWebApiPublicSiteDtoPublicSessionDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPublicSiteDtoPublicSessionDtoFromJSON(json: any): WebApiPublicSiteDtoPublicSessionDto {
    return WebApiPublicSiteDtoPublicSessionDtoFromJSONTyped(json, false);
}

export function WebApiPublicSiteDtoPublicSessionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPublicSiteDtoPublicSessionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isFamilyMember': !exists(json, 'isFamilyMember') ? undefined : json['isFamilyMember'],
        'familyMemberSelfServiceLimit': !exists(json, 'familyMemberSelfServiceLimit') ? undefined : json['familyMemberSelfServiceLimit'],
        'familyMemberCount': !exists(json, 'familyMemberCount') ? undefined : json['familyMemberCount'],
    };
}

export function WebApiPublicSiteDtoPublicSessionDtoToJSON(value?: WebApiPublicSiteDtoPublicSessionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isFamilyMember': value.isFamilyMember,
        'familyMemberSelfServiceLimit': value.familyMemberSelfServiceLimit,
        'familyMemberCount': value.familyMemberCount,
    };
}

